import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const CustomerInvestments = () => {
  const investmentData = [
    { id: 1, company: 'Apple Store', logo: '🍎', type: 'E-commerce, Marketplace', investmentValue: 54000, returnValue: '+16%' },
    { id: 2, company: 'Samsung Mobile', logo: 'G', type: 'E-commerce, Marketplace', investmentValue: 25300, returnValue: '-4%' },
    { id: 3, company: 'Tesla Motors', logo: 'T', type: 'Electric Vehicles', investmentValue: 8200, returnValue: '+25%' }
  ];

  const yearlyData = [
    { year: '2016', value: 30000 },
    { year: '2017', value: 45000 },
    { year: '2018', value: 55000 },
    { year: '2019', value: 48000 },
    { year: '2020', value: 65000 },
    { year: '2021', value: 58000 }
  ];

  const monthlyData = [
    { month: 'Jan', value: 35000 },
    { month: 'Feb', value: 28000 },
    { month: 'Mar', value: 42000 },
    { month: 'Apr', value: 38000 },
    { month: 'May', value: 45000 },
    { month: 'Jun', value: 48000 }
  ];

  return (
    <div className="bg-[#1A1A1A] p-6 rounded-xl border border-[#2A2A2A] shadow-xl">
      <div className="flex justify-between items-center mb-6">
        <div>
          <h3 className="text-lg font-semibold text-[#FFFFFF]">Customer Investments</h3>
          <div className="flex items-center mt-2 space-x-4">
            <div>
              <p className="text-sm text-[#B0B0B0]">Total Invested Amount</p>
              <p className="text-xl font-bold text-[#FFFFFF]">${(150000).toLocaleString()}</p>
            </div>
            <div>
              <p className="text-sm text-[#B0B0B0]">Number of Investments</p>
              <p className="text-xl font-bold text-[#FFFFFF]">1,250</p>
            </div>
            <div>
              <p className="text-sm text-[#B0B0B0]">Rate of Return</p>
              <p className="text-xl font-bold text-[#B4E50D]">+5.80%</p>
            </div>
          </div>
        </div>
        <div className="flex space-x-2">
          <button className="bg-[#B4E50D] text-[#0A0A0A] px-4 py-2 rounded-full font-medium hover:bg-[#B4E50D] transition-colors">
            Stocks
          </button>
          <button className="text-[#B0B0B0] px-4 py-2 rounded-full hover:text-[#FFFFFF] transition-colors">
            Mutual Funds
          </button>
        </div>
      </div>

      <div className="space-y-4">
        {investmentData.map((item) => (
          <div key={item.id} className="flex items-center justify-between p-4 border border-[#3A3A3A] rounded-lg bg-[#2A2A2A]">
            <div className="flex items-center space-x-4">
              <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${
                item.company === 'Apple Store' ? 'bg-[#FF6B6B] text-[#FFFFFF]' :
                item.company === 'Samsung Mobile' ? 'bg-[#B4E50D] text-[#0A0A0A]' : 'bg-[#FFD54F] text-[#0A0A0A]'
              }`}>
                {item.logo}
              </div>
              <div>
                <h4 className="font-medium text-[#FFFFFF]">{item.company}</h4>
                <p className="text-sm text-[#B0B0B0]">{item.type}</p>
              </div>
            </div>
            <div className="flex items-center space-x-8">
              <div>
                <p className="text-sm text-[#B0B0B0]">Investment Value</p>
                <p className="font-medium text-[#FFFFFF]">${item.investmentValue.toLocaleString()}</p>
              </div>
              <div>
                <p className="text-sm text-[#B0B0B0]">Return Value</p>
                <p className={`font-medium ${
                  item.returnValue.startsWith('+') ? 'text-[#B4E50D]' : 'text-[#FF6B6B]'
                }`}>{item.returnValue}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-2 gap-6 mt-6">
        <div>
          <h4 className="text-lg font-semibold mb-4 text-[#FFFFFF]">Yearly Total Investment</h4>
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={yearlyData}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#3A3A3A" />
                <XAxis dataKey="year" tick={{ fill: '#B0B0B0' }} />
                <YAxis tick={{ fill: '#B0B0B0' }} />
                <Tooltip 
                  contentStyle={{ 
                    backgroundColor: '#2A2A2A', 
                    border: '1px solid #3A3A3A',
                    borderRadius: '8px',
                    color: '#FFFFFF'
                  }}
                />
                <Line type="monotone" dataKey="value" stroke="#B4E50D" strokeWidth={2} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
        <div>
          <h4 className="text-lg font-semibold mb-4 text-[#FFFFFF]">Monthly Revenue</h4>
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={monthlyData}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#3A3A3A" />
                <XAxis dataKey="month" tick={{ fill: '#B0B0B0' }} />
                <YAxis tick={{ fill: '#B0B0B0' }} />
                <Tooltip 
                  contentStyle={{ 
                    backgroundColor: '#2A2A2A', 
                    border: '1px solid #3A3A3A',
                    borderRadius: '8px',
                    color: '#FFFFFF'
                  }}
                />
                <Line type="monotone" dataKey="value" stroke="#B4E50D" strokeWidth={2} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerInvestments;